import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_CONDITIONAL_KICKSTART = defineFcm('starfish_conditional_kickstart')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig();
